import ChallengesMap from "../views/ChallengesMap";
import "select2";

export default class Challenges {
  constructor() {
    this.challengesMap = new ChallengesMap();
    this.bindEvents();
    this.setupSmoothScroll();
  }

  setupSmoothScroll() {
    // Scroll to anchor on page load with a small delay to ensure DOM is ready
    const hash = window.location.hash;
    if (hash) {
      // Use setTimeout to ensure all elements are loaded before scrolling
      setTimeout(() => {
        this.smoothScrollTo(hash);
      }, 300);
    }

    // Setup click handlers for anchor links
    $('a[href^="#"]').on('click', (e) => {
      const href = $(e.currentTarget).attr('href');
      if (href && href !== '#') {
        e.preventDefault();
        this.smoothScrollTo(href);
        history.pushState(null, null, href);
      }
    });
  }

  smoothScrollTo(selector) {
    const target = $(selector);
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top - 100
      }, 800, 'swing'); // Added duration and easing for smoother animation
    }
  }

  bindEvents() {
    const self = this;

    window.$("#js-activity-live-select").select2({
      theme: "bootstrap4",
      width: '100%', // Make Select2 responsive instead of fixed width
      templateResult: this.formatActivity,
      templateSelection: this.formatActivity,
      language: I18n.locale,
    });

    $('b[role="presentation"]').hide();
    $(".select2-selection__arrow").append('<i class="fas fa-chevron-down fs-12"></i>');
    $(".select2-selection__arrow").addClass("home_custom_arrow_select2");

    $("#js-activity-live-select").on("change", function () {
      self.updateCategory($(this).val());
    });
  }

  formatActivity(act) {
    let $act = "";
    if (!act.id) {
      return act.name;
    } else if ($(act.element).val() === "0") {
      $act = $('<span class="mt-2 d-block">' + act.text + "</span>");
    } else {
      $act = $(
        '<span class="lh-5">\n<span class="bg-secondary dot mr-2 fs-20"><i class="text-white icon icon-' +
          $(act.element).data("icon") +
          '"></i></span>' +
          act.text +
          "</span>"
      );
    }
    return $act;
  }

  updateCategory(category_id) {
    this.challengesMap.category_id = parseInt(category_id);
    this.challengesMap.showAllChallenges = false;
    this.challengesMap.clearCurrentContestTask();
    this.challengesMap.loadContestTasks();
  }

  onDestroy() {
    window.$("#js-activity-live-select").select2("destroy");
    $("#js-activity-live-select").off("change");
    $('a[href^="#"]').off('click');

    if (this.challengesMap) {
      this.challengesMap.destroy();
    }
  }
}
